<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="left"
          status-icon
          :inline-message="true"
          label-width="auto"
        >
          <el-form-item label="头像：">
            <el-upload
              class="avatar-uploader"
              action="#"
              :http-request="uploadPic"
              accept="image/*"
              capture="camera"
              :show-file-list="false"
              :on-change="handlePictureCardPreviewHead"
            >
              <!-- :before-upload="beforeAvatarUpload" -->
              <el-image
                v-if="headUrl"
                :src="headUrl"
                class="avatar"
                fit="contain"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
          </el-form-item>
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="form.name" size="small" />
          </el-form-item>
          <el-form-item label="用户名：" prop="realName">
            <el-input v-model="form.realName" placeholder="请输入新用户名" size="small" />
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入新手机号" size="small" />
          </el-form-item>
          <el-form-item label="邮箱：" prop="data4">
            <el-input v-model="form.email" placeholder="请输入新邮箱" size="small" />
          </el-form-item>
          <el-form-item>
            <router-link :to="{ path: '/user' }">
              <el-button size="mini" type="info"> 返回 </el-button>
            </router-link>
            <el-button size="mini" type="primary" @click="submit('form')">
              修改
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import { compress } from "@/utils/file";
import { filtration$ } from "@/utils/admin";
import formRules from "@/utils/formRules.js";
import { postFile } from "@/api/file";
import { getDetail, postUpdateInfo } from "@/api/user/index";
let headUrlSuccess = 0;
export default {
  data() {
    return {
      form: {
        name: "",
        realName: "",
        phone: "",
      },
      headUrl: "",
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        realName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "联系电话不能为空" },
          { validator: formRules.validatePhone, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.$store.dispatch("submitToken");
    this.detail();
  },
  methods: {
    // 用户信息
    detail() {
      getDetail().then((res) => {
        this.form = res.data;
        this.headUrl = res.data.url;
      });
    },
    uploadPic() {},
    // 照片上传后回显
    handlePictureCardPreviewHead(file) {
      if (file.status == "ready") {
        let _that = this;
        let params = {};
        params.folderName = "head_portrait";
        const isLt10M = file.size / 1024 / 1024 < 15;
        const isLt1M = file.size / 1021 / 1024 < 1;
        if (!isLt10M) {
         _that.$notify({ type: "error", message: "上传图片大小不能超过 15M！" });
          return false;
        } else if (isLt1M) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = (e) => {
            if (e.currentTarget.result.search("png") !== -1) {
              params.format = "png";
              let base64 = e.currentTarget.result.replace("data:image/png;base64,", "");
              params.content = base64;
            }
            if (e.currentTarget.result.search("jpeg") !== -1) {
              params.format = "jpeg";
              let base64 = e.currentTarget.result.replace("data:image/jpeg;base64,", "");
              params.content = base64;
            }
            postFile(params).then((res) => {
              if (res.code == 200) {
                _that.headUrl = res.data.url;
                _that.form.avatar = res.data.path;
                _that.$notify({ type: "success", message: "照片选择成功！" });
                headUrlSuccess = 1;
              } else {
                _that.$notify({ type: "error", message: "照片选择失败！请重新选择。" });
              }
            });
          };
        } else {
          this.headUrl = URL.createObjectURL(file.raw);
          compress(file.raw, function (val) {
            let newFile = new window.File([val], file.name, { type: file.raw.type });
            newFile.uid = file.uid;
            let reader = new FileReader();
            reader.readAsDataURL(newFile);
            reader.onload = (e) => {
              if (e.currentTarget.result.search("png") !== -1) {
                params.format = "png";
                let base64 = e.currentTarget.result.replace("data:image/png;base64,", "");
                params.content = base64;
              }
              if (e.currentTarget.result.search("jpeg") !== -1) {
                params.format = "jpeg";
                let base64 = e.currentTarget.result.replace(
                  "data:image/jpeg;base64,",
                  ""
                );
                params.content = base64;
              }
              postFile(params).then((res) => {
                if (res.code == 200) {
                  // _that.headUrl = res.data.url;
                  _that.form.avatar = res.data.path;
                  _that.$notify({ type: "success", message: "照片选择成功！" });
                  headUrlSuccess = 1;
                } else {
                  _that.$notify({
                    type: "warning",
                    message: "照片选择失败！请重新选择。",
                  });
                }
              });
            };
          });
        }
      }
    },
    submit(form) {
      if ((headUrlSuccess = 1)) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            postUpdateInfo(filtration$(this.form))
              .then((res) => {
                if (res.code == 200) {
                  this.$notify({ type: "success", message: "修改成功！" });
                  // 暂留
                  // this.$router.back();
                }
              })
              .catch((error) => {
                this.$store.dispatch("submitToken");
              });
          }
        });
      } else if ((headUrlSuccess = 0)) {
        this.$notify({ type: "warning", message: "请耐心等待照片上传完毕！" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  min-height: 100vh;
  background-color: #f0f0f0;
}
.content {
  padding: 10px;
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-form-item {
    margin: 0;
    padding-bottom: 5px;
  }
  /deep/ .el-form-item__content {
    line-height: unset;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 90px;
    height: 90px;
    line-height: 90px;
    text-align: center;
  }
  .avatar {
    width: 90px;
    height: 90px;
    display: block;
  }
}
</style>
